import React from "react";

import { Form } from "react-bootstrap";

import { Control, Controller, FieldError, FieldErrors, FieldValues, Path } from "react-hook-form";

import { ParticipantTypes } from "@api/graphql";
import { mandatoryFields } from "@pages/register/hooks/errorResolver";
import { states } from "@util/states";

import { FormErrorText } from "./FormErrorText";

interface StateDropdownProps<TFieldValues extends FieldValues, TField extends Path<TFieldValues>> {
  fieldName: TField;
  control: Control<TFieldValues>;
  isDisabled: boolean;
  isInvalid?: boolean;
  isInternalUserCreatingAccount: boolean;
  errors?: FieldErrors<TFieldValues>;
  isAccountActive?: boolean;
  accountStatus?: string;
  participantTypes?: ParticipantTypes[];
}

const StateDropdown = <TFieldValues extends FieldValues, TField extends Path<TFieldValues>>({
  fieldName,
  control,
  isDisabled,
  isInternalUserCreatingAccount,
  errors,
  isInvalid,
  isAccountActive,
  accountStatus,
  participantTypes,
}: StateDropdownProps<TFieldValues, TField>) => {
  return (
    <Form.Group controlId="State">
      <Form.Label>
        {mandatoryFields.accountDetails.address.state({
          isInternalUserCreatingAccount,
          isAccountActive,
          accountStatus,
          participantTypes,
        }) && "* "}
        State
      </Form.Label>
      <Controller
        name={fieldName}
        control={control}
        render={({ field }) => (
          <Form.Select
            {...field}
            isInvalid={isInvalid}
            disabled={isDisabled}
            className={field.value && "custom-select-value-selected"}
          >
            <option hidden value="">
              State / Territory
            </option>
            {states.map((state) => (
              <option key={state} value={state}>
                {state}
              </option>
            ))}
            <option value="N/A">N/A</option>
          </Form.Select>
        )}
      />
      <FormErrorText error={errors?.[fieldName] as FieldError}></FormErrorText>
    </Form.Group>
  );
};

export default StateDropdown;
